export default {"src":"/_next/static/image/public/imgs/es/favicon-light.5ff934b1f3e47a9c425d185917c65ccf.ico","height":159,"width":159};